export default "__VITE_ASSET__JtCGgAW___"